import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogOptions } from 'app/models/confirm-dialog-options.models';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
  title: string;
  message: string;
  options: ConfirmDialogOptions;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    public _dialogRef: MatDialogRef<ConfirmDialogComponent>,
  ) {
    this.title = data.title;
    this.message = data.message;
    this.options = data.options;
  }

  onConfirm(): void {
    // Close the dialog, return true
    this._dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false
    this._dialogRef.close(false);
  }
}
